import { type ApiCompanySummary } from "../../models/api/admin/company";
import { type ApiDepartmentSummary } from "../../models/api/admin/department";
import ReportingBox from "./ReportingBox";
import { premadeReports } from "./premadeReports";
import { useSpreadsheetReportDownload } from "../../pages/Admin/pageHooks/useSpreadsheetReportDownload";
import { API_SETTINGS_STORAGE_KEY } from "../../hooks/useDueToExpireSettings";
import { ApiSettingsResponse } from "../../models/api/admin/apiSettings";
import useSessionStorage from "../../hooks/useSessionStorage/useSessionStorage";

type ReportingOptionsProps = {
    selectedCompany: ApiCompanySummary | null;
    selectedDepartment: ApiDepartmentSummary | null;
};

const ReportingOptions: React.FC<ReportingOptionsProps> = ({
    selectedCompany,
    selectedDepartment,
}) => {
    const { handleDownloadReport, isReportDownloading } =
        useSpreadsheetReportDownload(selectedCompany, selectedDepartment);

    const handleDeleteReport = (id: string) => {
        alert(`delete report ${id}`);
    };
    
    const [storedDueToExpireSettings] =
        useSessionStorage<ApiSettingsResponse | null>(
            API_SETTINGS_STORAGE_KEY,
            null
        );
    
    // this is needed to override the hardcoded value of expiry days     
    const licenceExpiryDays = storedDueToExpireSettings?.dueToExpireLicenceCategoryDays ?? 56;

    const premadeReportsArray = premadeReports(licenceExpiryDays);

    return (
        <div className="flex flex-col gap-6">
            {premadeReportsArray.map((report) => (
                <div key={report.id}>
                    <ReportingBox
                        reportingBoxOption={report}
                        handleDownloadReport={handleDownloadReport}
                        isReportDownloading={isReportDownloading}
                        handleDeleteReport={handleDeleteReport}
                        isDeletingReport={false}
                    />
                </div>
            ))}
            {/* then map over custom reports */}
        </div>
    );
};

export default ReportingOptions;
